import { IdentityDocumentEntity } from 'api/types/entity';
import { TFunc } from 'libs/i18n';

import { IdentityDocumentFormType } from '../../forms/identityDocumentWithFilesForm';

import { parseIdentityDocumentInitialValue } from './parseIdentityDocumentInitialValue';

export const parseIdentityDocumentWithFilesInitialValue = (
  t: TFunc,
  identityDocument?: IdentityDocumentEntity
) => {
  const values: IdentityDocumentFormType['identityDocument'] = identityDocument
    ? {
        ...parseIdentityDocumentInitialValue(t, identityDocument),
        files: identityDocument.files,
      }
    : ({} as IdentityDocumentFormType['identityDocument']);

  return values;
};
